import {BaseCachedService} from './Core/BaseCachedService';

class SpeciesListTypeService extends BaseCachedService {
    get Url() { return super.Url + "/speciesListTypes"; }
    get ModelName() { return "SpeciesListType"; }
    get PrimaryKeyProperty() { return "speciesListTypeId"; }
}

export const service = new SpeciesListTypeService();

